module.exports = __webpack_public_path__ + "media/icons/load-more-cars-arrow@2x-a8151612.png";